define('app/factories/scroll_to_anchor',['app/setup', 'app/views/scroll_to_anchor'], function(takhfifan, scrollToAnchor) {
  $('.tkh-scroll_to_anchor').each(function(){
    new takhfifan.scrollToAnchor({
      el: $(this)
    });
  });
});


